package mapsearch.globalsearch

import apiclient.geoobjects.GeoObjectDetails
import apiclient.geoobjects.pointGeometry
import apiclient.mapsearch.MapMarker
import apiclient.mapsearch.MapMarkerResult
import apiclient.users.UserProfileSummary
import apiclient.users.toUserProfileSummary
import data.users.UserListStore
import koin.withKoin
import kotlinx.datetime.Instant

/**
 * Converts MapMarker to MapMarkerResult (to merge results in ClusterPreview)
 * Use carefully, as MapMarker can not fill all the fields
 */
//fun MapMarker.toMapMarkerResult(): MapMarkerResult {
//    return MapMarkerResult(
//        id = id,
//        objectType = ObjectType.POI,
//        title = title,
//        ownerId = ownerId,
//        geometry = geometry,
//        updatedAt = updatedAt,
//        icon = icon,
//        color = color,
//        shape = shape,
//        content = content,
//        tags = keywords?.map { ObjectTags.Keyword.tag(it) }.orEmpty(),
//    )
//}

fun GeoObjectDetails.toMapMarker(): MapMarker {
    return MapMarker(
        id = id,
        title = title,
        ownerId = ownerId,
        geometry = geometry ?: latLon.pointGeometry(),
        updatedAt = updatedAt.let { Instant.parse(it) },
        icon = iconCategory?.name,
        color = color?.name,
        shape = shape?.name,
        content = attachments,
    )
}

fun GeoObjectDetails.toMapMarkerResult(): MapMarkerResult {
    return MapMarkerResult(
        id = id,
        objectType = objectType,
        title = title,
        ownerId = ownerId,
        geometry = geometry ?: latLon.pointGeometry(),
        updatedAt = updatedAt.let { Instant.parse(it) },
        atTime = atTime?.let { Instant.parse(it) },
        icon = iconCategory?.name,
        color = color?.name,
        shape = shape?.name,
        content = attachments,
        tags = tags,
    )
}

fun MapMarkerResult.owner(): UserProfileSummary? {
    val marker = this
    withKoin {
        val userListStore: UserListStore = get()
        return userListStore.current?.firstOrNull { marker.ownerId == it.userId }?.toUserProfileSummary()
    }
}

fun MapMarkerResult.toMapMarker(): MapMarker? {
    return geometry?.let {
        MapMarker(
            id = id,
            title = title,
            ownerId = ownerId,
            geometry = it,
            updatedAt = updatedAt,
            icon = icon,
            color = color,
            shape = shape,
            content = content,
        )
    }
}
